import { Api } from '@/api/api';
import { SystemSetting } from '@/shared/system-setting';

export class SettingApi extends Api {
    public getSettingsAsync(): Promise<Array<SystemSetting>> {
        return this.getAsync<Array<SystemSetting>>(`v1/setting`);
    }

    public async updateSettingAsync(setting: SystemSetting): Promise<void> {
        await this.putAsync(`v1/setting`, { ...setting });
    }

    public constructor() {
        super();
    }
}
